import { Component, inject, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { eps } from '../../../../services/url.service'
import { filter, take, tap } from 'rxjs'
import { CommonModule, NgSwitch } from '@angular/common'
import { EarningsComponent } from '../earnings/earnings.component'
import { ReviewComponent } from '../review/review.component'
import { SuccessComponent } from '../success/success.component'
import { selectRunningPayroll } from '../../../../store/contractor-payroll/contractor-payroll.reducers'
import { ContractorPayrollStatus } from '../../../../store/contractor-payroll/contractor-payroll.state'

@Component({
  selector: 'app-run-contractor-payroll',
  imports: [
    NgSwitch,
    CommonModule,
    RouterModule,
    EarningsComponent,
    ReviewComponent,
    SuccessComponent
  ],
  templateUrl: './run-contractor-payroll.component.html',
  styleUrl: './run-contractor-payroll.component.scss'
})
export class RunContractorPayrollComponent implements OnInit {
  private store = inject(Store)
  private router = inject(Router)
  eps = eps
  screens = [0, 1, 2]
  runningPayroll$ = this.store.select(selectRunningPayroll)

  //---State---//
  currentScreenIndex = 0

  ngOnInit(): void {
    //this.store.dispatch(runningPayrollActions.clearPreviousSalaries())
    //this.store.dispatch(runningPayrollActions.clearArrearLopDays())
    this.runningPayroll$
      .pipe(
        filter(runningPayroll => runningPayroll !== undefined),
        take(1),
        tap(runningPayroll => {
          if (runningPayroll === null) this.router.navigate([eps.hrm.manageContractorPayrollPath])
          if (
            runningPayroll?.status === ContractorPayrollStatus.PROCESSED ||
            runningPayroll?.status === ContractorPayrollStatus.PAID
          ) {
            this.currentScreenIndex = 1
          }
        })
      )
      .subscribe()
  }

  changeScreen(value: boolean) {
    if (value) this.currentScreenIndex++
    else this.currentScreenIndex--
  }
}
